import { useDispatch, useSelector } from "react-redux";
import { AddressSuggestions } from "react-dadata";


import { nextStep, setCountOfferL, setCountOfferP, setMinPremiumL, setMinPremiumP } from './formSlice';

import icon_s3_2 from '../../static/img/icon-s3-2.svg';
import icon_s3_1 from '../../static/img/icon-s3-1.svg';
import { useState } from "react";
import { preCalcNew } from "../precalc/precalcApi";
import { selectCookie, selectMortgageBalance, selectToken, selectTokenVsk, setMortgageBalance } from "../precalc/precalcSlice";
import { selectIdBank } from "../calc/calcSlice";
import { TYPES_OBJECTS, list_banks } from "../../static/vars";
import { selectRegAdr, setFiasIdRegAddr, setKladrIdRegAddr, setRegAdr } from "../calc/personSlice";

export function StepOne(props) {
    const dispatch = useDispatch();

    const cookie = useSelector(selectCookie)
    const token = useSelector(selectToken)
    const token_vsk = useSelector(selectTokenVsk)

    const [showDropDown, setShowDropDown] = useState(false);
    const [showDropDownBank, setShowDropDownBank] = useState(false);
    const mortgageBalance = useSelector(selectMortgageBalance)
    const [typeObject, setTypeObject] = useState('Квартира');
    const idBank = props.idBank
    const setIdBank = props.setIdBank

    const [isLoad, setIsLoad] = useState(false);

    const regAdr = useSelector(selectRegAdr)

    const handleNext = (e) => {
        setIsLoad(true)
        preCalcNew({
            token: token,
            cookie: cookie,
            token_vsk: token_vsk,
            limit_sum: mortgageBalance,
            id_bank: idBank,
            sex: 'М',
            is_life: true,
            is_property: true,
            birthday: new Date('2000-01-01').toISOString().slice(0, -5),
        }, (data) => {
            setIsLoad(false)
            console.log('preCalcNew', data)
            // if (data.premiums.property.length > 0) setIsLoad(false)
            console.log('preCalcNew', data)
            let count_offer_property = 0
            let count_offer_life = 0
            let min_premium_property = 1000000000
            let min_premium_life = 1000000000

            // if ((data.premiums.property.length === 0 && propertyOption) || (data.premiums.life.length === 0 && lifeOption)) {
            //     setNotCompany(true)
            //     setIsLoad(false)
            // }

            for (let i = 0; i < data.premiums.property.length; i++) {


                if (data.premiums.property[i]?.premium) {
                    count_offer_property++
                    if (data.premiums.property[i].premium < min_premium_property) {
                        min_premium_property = data.premiums.property[i].premium
                    }
                }
            }

            for (let i = 0; i < data.premiums.life.length; i++) {

                if (data.premiums.life[i]?.premium) {
                    count_offer_life++
                    if (data.premiums.life[i].premium < min_premium_life) {
                        min_premium_life = data.premiums.life[i].premium
                    }
                }

            }

            dispatch(setMinPremiumP(min_premium_property))
            dispatch(setMinPremiumL(min_premium_life))
            dispatch(setCountOfferP(count_offer_property))
            dispatch(setCountOfferL(count_offer_life))
            dispatch(nextStep());

        })

    }

    const handleShowListTypeObject = () => {
        setShowDropDown(!showDropDown)
    }

    const handleShowListBank = () => {
        setShowDropDownBank(!showDropDownBank)
    }

    const handleChangeMortgageBalance = (e) => {
        dispatch(setMortgageBalance(e.target.value))
    }

    function handleClickObject(index) {
        setTypeObject(TYPES_OBJECTS[index].text)
        setShowDropDown(false)
    }

    function handleClickBank(value) {
        setIdBank(value)
        setShowDropDownBank(false)
    }

    const handleChangeRegAdr = (e) => {
        dispatch(setKladrIdRegAddr(e.data.kladr_id))
        dispatch(setFiasIdRegAddr(e.data.fias_id))
        dispatch(setRegAdr(e.value))
    }

    return (
        <div className="one-ekran-contant-lending-step one-ekran-contant-lending-step-1" style={{ display: 'block' }}>
            <p className="lending-step-text">Заполни форму и получи 3% дополнительной скидки</p>
            {!isLoad &&
                <form className="form-popup form-popup-1">
                    <div className="one-ryad one-ryad-popup one-ryad-popup-3  one-ryad-popup-user one-ryad-popup-user-9">
                        <div className="form-group">
                            <div className="dropdown">
                                <label htmlFor="select-1">Тип объекта </label>
                                <div onClick={handleShowListTypeObject} className="dropdown__button dropdown__button-popup dropdown__button-popup-user">{typeObject}</div>
                                {showDropDown &&
                                    <ul className="dropdown__list">
                                        {
                                            TYPES_OBJECTS.map((object, index) => {
                                                return (
                                                    <li
                                                        key={index}
                                                        class="dropdown__list-item"
                                                        onClick={() => handleClickObject(index)}
                                                    >
                                                        {object.text}<span>{object.comment}</span>
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>


                                }
                                <input type="text" name="select-category" defaultValue="" className="dropdown__input-hidden" />
                            </div>
                        </div>
                    </div>
                    <div className="one-ryad one-ryad-popup one-ryad-popup-3  one-ryad-popup-user one-ryad-popup-user-10">
                        <div className="form-group">
                            <div className="dropdown">
                                <label htmlFor="select-1">Банк кредитор</label>
                                <div onClick={handleShowListBank} className="dropdown__button dropdown__button-popup dropdown__button-popup-user">{list_banks.find(x => x.value === idBank).label}</div>
                                {showDropDownBank &&
                                    <ul className="dropdown__list">
                                        {
                                            list_banks.map((bank, index) => {
                                                return (
                                                    <li key={index}
                                                        class="dropdown__list-item"
                                                        onClick={() => handleClickBank(bank.value)}
                                                    >
                                                        {bank.label}
                                                    </li>
                                                )
                                            })
                                        }
                                    </ul>
                                }
                                <input type="text" name="select-category" defaultValue="" className="dropdown__input-hidden" />
                            </div>
                        </div>
                    </div>
                    <div className="one-ryad one-ryad-popup one-ryad-popup-1 one-ryad-popup-user one-ryad-popup-user-11">
                        <label htmlFor="select-1">Остаток по ипотеке, ₽</label>
                        <input
                            className="pole-popup pole-popup-user pole-popup-1 pole-popup-00"
                            type="text" placeholder="100 000 ₽" required=""
                            value={mortgageBalance}
                            onChange={handleChangeMortgageBalance}
                        />
                    </div>
                    <div className="one-ryad one-ryad-popup one-ryad-popup-1 one-ryad-popup-user one-ryad-popup-user-12">
                        <label htmlFor="select-1">Адрес объекта недвижимости</label>
                        {/* <input className="pole-popup pole-popup-user pole-popup-1 pole-popup-00" name="Адрес" type="text" placeholder="----------" required="" /> */}
                        <AddressSuggestions
                            inputProps={{
                                className: "pole-popup pole-popup-user pole-popup-1 pole-popup-00"
                            }}
                            defaultQuery={regAdr}
                            token="93bd729e5209d96326b970b0f8cdd5f0ce2ef6bd"
                            value={regAdr}
                            onChange={handleChangeRegAdr} />
                    </div>
                    <p className="lending-step-text-2">Страхуем:</p>
                    <div className="lending-step-text-row">
                        <div className="lending-step-text-item lending-step-text-item-1">
                            <label className="lending-step-text-item-vnutr lending-step-text-item lending-step-text-item-1 lending-step-text-3" htmlFor="zakon" id="lending-step-text-item-vnutr-1">
                                <input className="checkbox-1 checkbox-1-1" type="checkbox" id="zakon" name="zakon-1" defaultValue="" />
                                <img src={icon_s3_1} alt="home" />Недвижимость
                            </label>
                        </div>
                        <div className="lending-step-text-item lending-step-text-item-2">
                            <label className="lending-step-text-item-vnutr lending-step-text-item lending-step-text-item-1 lending-step-text-3" htmlFor="zakon-1" id="lending-step-text-item-vnutr-2">
                                <input className="checkbox-1 checkbox-1-2" type="checkbox" id="zakon-1" name="zakon-2" defaultValue="" />
                                <img src={icon_s3_2} alt="home" />Жизнь и здоровье
                            </label>
                        </div>
                    </div>
                    <div onClick={handleNext} className="button button-1 button-popup-1 button-lending-1">Рассчитать стоимость</div>
                </form>
            }

            {isLoad &&
                <div class="blok-info-animation">
                    <div class="circle-box" id="circle-box">
                        <div class="circle circle-1 slideInDown wow"></div>
                        <div class="circle circle-2 slideInDown1 wow"></div>
                        <div class="circle circle-3 slideInDown2 wow"></div>
                    </div>
                </div>
            }
        </div>
    )
}
